import { Box, Stack, Typography } from "@mui/material";
import { PhoneInputField, Select, TextField } from "components/UI";
import { ErrorMessage } from "components/UI/ErrorMessage";
import { isEmpty } from "lodash";
import { memo } from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

const StructureProfileSection = memo(
  ({
    register,
    control,
    errors,
    mutationError,
    structureTypeOptions,
    parentStructureOptions,
    isLoadingStructureTypes,
    isLoadingDenominations
  }) => {
    const { t } = useTranslation();

    return (
      <Box>
        <Typography variant="h6" sx={{ mb: 1 }}>
          {t("denominations.structures.structureProfile")}
        </Typography>
        <Stack spacing={1}>
          <TextField
            hasNoBg={true}
            label={t("denominations.structures.structureName")}
            name="name"
            error={
              !!errors.name?.message || !isEmpty(mutationError?.errors?.name)
            }
            helperText={
              errors.name?.message || (
                <ErrorMessage messages={mutationError?.errors?.name} />
              )
            }
            register={register}
          />
          <TextField
            hasNoBg={true}
            label={t("denominations.structures.structureAcronym")}
            name="acronyms"
            error={
              !!errors.acronyms?.message ||
              !isEmpty(mutationError?.errors?.acronyms)
            }
            helperText={
              errors.acronyms?.message || (
                <ErrorMessage messages={mutationError?.errors?.acronyms} />
              )
            }
            register={register}
          />

          <Select
            hasNoBg={true}
            isLabelBold={0}
            label={t("denominations.structures.structureType")}
            name="denomination_structure_type_id"
            options={[
              {
                optionLabel: t("denominations.structures.selectStructureType"),
                value: "",
                disabled: true
              },
              ...structureTypeOptions
            ]}
            register={register}
            error={
              !!errors.denomination_structure_type_id?.message ||
              !isEmpty(mutationError?.errors?.denomination_structure_type_id)
            }
            helperText={errors.denomination_structure_type_id?.message}
            disabled={isLoadingStructureTypes}
          />

          <Select
            hasNoBg={true}
            isLabelBold={0}
            label={t("denominations.structures.parentStructure")}
            name="parent_id"
            options={[
              {
                optionLabel: t(
                  "denominations.structures.selectParentStructure"
                ),
                value: "",
                disabled: true
              },
              ...parentStructureOptions
            ]}
            register={register}
            error={
              !!errors.parent_id?.message ||
              !isEmpty(mutationError?.errors?.parent_id)
            }
            helperText={errors.parent_id?.message}
            disabled={isLoadingDenominations}
          />

          <TextField
            hasNoBg={true}
            label={t("form.common.email")}
            name="email"
            error={
              !!errors.email?.message || !isEmpty(mutationError?.errors?.email)
            }
            helperText={
              errors.email?.message || (
                <ErrorMessage messages={mutationError?.errors?.email} />
              )
            }
            register={register}
          />

          <Controller
            name="phone"
            control={control}
            render={({ field }) => (
              <PhoneInputField
                label={t("denominations.structures.structurePhone")}
                error={
                  !!errors.phone?.message ||
                  !isEmpty(mutationError?.errors?.phone)
                }
                helperText={
                  errors.phone?.message || (
                    <ErrorMessage messages={mutationError?.errors?.phone} />
                  )
                }
                {...field}
              />
            )}
          />

          <TextField
            hasNoBg={true}
            label={t("form.common.pobox")}
            name="p_o_box"
            error={
              !!errors.p_o_box?.message ||
              !isEmpty(mutationError?.errors?.p_o_box)
            }
            helperText={
              errors.p_o_box?.message || (
                <ErrorMessage messages={mutationError?.errors?.p_o_box} />
              )
            }
            register={register}
          />
        </Stack>
      </Box>
    );
  }
);

StructureProfileSection.displayName = "StructureProfileSection";

export default StructureProfileSection;
